<template>
    <section class="vraag w100 clearfix">
        <div class="w100 input" :class="[error ? 'error-checkbox' : '']">
            <div class="checkbox" v-for="(option, key) in options" :key="key">
                <input
                    type="checkbox"
                    :id="'chk-'+ name + '-' + option.value"
                    class="input-checkbox"
                    :checked="value && value.includes(option.value)"
                    autocomplete="off"
                    @change="updateChecked(option.value)"
                >
                <label :for="'chk-'+ name + '-' + option.value">{{ option.label }}&nbsp;<img v-if="option.title" src="@/assets/icons/help.png" :title="option.title"></label>
            </div>
             <div class="tooltip bottom" :style="style">
                <div class="tooltip-arrow"></div>
                <div class="tooltip-inner">{{ error }}</div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
            checked: []
        }
    },
    props: {
        name: String,
        options: Array,
        value: Array,
        error: String
    },
    computed: {
        style() {

            return "top:" + ((this.options.length * 45) - 16) + "px";
        }
    },
    methods: {
        updateChecked(value) {
            if(this.checked.includes(value)) {
                const i = this.checked.indexOf(value);
                this.checked.splice(i, 1);
            } else {
                this.checked.push(value);
            }

            this.$emit('input', this.checked);
        }
    }
}
</script>
